import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useNetLoading} from '@adv-mt/mt-net-drawer'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {AiIcon} from '@adv-mt/ui/ai-icon'
import {Button, BUTTON_INTENTS, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'

const AssistantButton = ({isOpen, setIsOpen, pageName}) => {
  const {i18n, domain} = useContext(Context)
  const {track} = useAnalyticsTrack()
  const {isLoading: isNetLoading, hasNetFinishedLoading, clearNetFinishedLoadingBadge} = useNetLoading()

  const config = domain.get('config')
  const {
    TRACKING_EVENT_NAMES: {NET_ASSISTANT_ACCESS_CLICKED},
    HIT_INFORMATIONS: {NET_ASSISTANT_HEADER_MENU}
  } = config.get('tracking')

  const isLoading = !isOpen && isNetLoading

  const onClick = () => {
    clearNetFinishedLoadingBadge()
    setIsOpen(!isOpen)
    track({
      event: NET_ASSISTANT_ACCESS_CLICKED,
      data: {hit_origin: pageName, hit_information2: NET_ASSISTANT_HEADER_MENU}
    })
  }

  return (
    <Button
      variant={BUTTON_VARIANTS.OUTLINE}
      intent={BUTTON_INTENTS.AI}
      shape={BUTTON_SHAPES.CIRCLE}
      size={BUTTON_SIZES.MEDIUM}
      isLoading={isLoading}
      hasNotification={!isOpen && hasNetFinishedLoading}
      onClick={onClick}
      aria-expanded={isOpen}
      aria-haspopup="dialog"
      aria-controls="assistant-drawer"
      aria-label={i18n.t('NET.ACCESS.ARIA_LABEL')}
    >
      <AiIcon loading={isLoading} />
    </Button>
  )
}

AssistantButton.displayName = 'AssistantButton'

AssistantButton.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  pageName: PropTypes.string
}

export default AssistantButton
